import { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Phone, Menu, X } from "lucide-react";

const Navigation = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const location = useLocation();

  const navItems = [
    { path: "/", label: "Accueil" },
    { path: "/services", label: "Services" },
    { path: "/a-propos", label: "À propos" },
    { path: "/realisations", label: "Réalisations" },
    { path: "/contact", label: "Contact" },
  ];

  const handleContactClick = () => {
    window.location.href = "tel:0658864706";
  };

  return (
    <nav className="bg-white shadow-sm sticky top-0 z-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center py-4">
          {/* Logo */}
          <Link to="/" className="flex items-center space-x-3">
            <img 
              src="https://skyagent-artifacts.skywork.ai/page/g4fx3zsin9/images/LOGO.jpeg" 
              alt="Logo JS Concept" 
              className="h-16 w-auto"
            />
          </Link>

          {/* Desktop Navigation */}
          <div className="hidden lg:flex items-center space-x-8">
            {navItems.map((item) => (
              <Link
                key={item.path}
                to={item.path}
                className={`text-sm font-medium transition-colors hover:text-primary ${
                  location.pathname === item.path
                    ? "text-primary border-b-2 border-primary"
                    : "text-gray-700"
                }`}
              >
                {item.label}
              </Link>
            ))}
          </div>

          {/* CTA Button */}
          <Button 
            onClick={handleContactClick}
            className="hidden lg:flex bg-secondary hover:bg-secondary/90"
          >
            <Phone className="h-4 w-4 mr-2" />
            Devis Gratuit
          </Button>

          {/* Mobile Menu Button */}
          <button
            onClick={() => setIsMenuOpen(!isMenuOpen)}
            className="lg:hidden p-2"
          >
            {isMenuOpen ? <X className="h-6 w-6" /> : <Menu className="h-6 w-6" />}
          </button>
        </div>

        {/* Mobile Navigation */}
        {isMenuOpen && (
          <div className="lg:hidden border-t border-gray-200 py-4">
            <div className="flex flex-col space-y-4">
              {navItems.map((item) => (
                <Link
                  key={item.path}
                  to={item.path}
                  onClick={() => setIsMenuOpen(false)}
                  className={`text-sm font-medium transition-colors hover:text-primary ${
                    location.pathname === item.path
                      ? "text-primary"
                      : "text-gray-700"
                  }`}
                >
                  {item.label}
                </Link>
              ))}
              <Button 
                onClick={() => {
                  handleContactClick();
                  setIsMenuOpen(false);
                }}
                className="bg-secondary hover:bg-secondary/90 w-full"
              >
                <Phone className="h-4 w-4 mr-2" />
                Devis Gratuit
              </Button>
            </div>
          </div>
        )}
      </div>
    </nav>
  );
};

export default Navigation;